import React from "react";
import { Container, Grid } from "@mui/material";
import stacking from "../../images/stacking.png"
import lottery from "../../images/lottery.png"
import governance from "../../images/governance.png"

const Features = () => {
    return(
        <div id="features" className="OS---Features py-5">
            <Container>
                <Grid
                    container
                    justifyContent="center"
                    alignContent="center"
                    alignItems="center"
                    className="py-md-5"
                >
                    <Grid
                        xs={12}
                    >
                        <h2 className="OS---sectionHeading">Features</h2>
                    </Grid>
                    <Grid
                        xs={12}
                        md={8}
                        lg={6}
                        container
                        justifyContent="center"
                        alignContent="center"
                    >
                        <Grid
                            xs={12}
                        >
                            <p className="text-center mx-auto mb-4" style={{maxWidth: 500}}>
                                Lorem ipsum dolor sit amet, consetetur sadipscing elitr, sed diam nonumy 
                                eirmod tempor invidunt ut labore et dolore magna aliquyam erat, sed diam 
                                voluptua. At vero eos et accusam et justo duo dolores et ea rebum. 
                            </p>
                        </Grid>
                        <Grid
                            xs={12}
                            sm={4}
                            className="OS---Features-card"
                        >
                            <div>
                                <div className="py-4 mb-3">
                                    <img src={stacking} />
                                </div>
                                <h6>Stacking</h6>
                            </div>
                        </Grid>
                        <Grid
                            xs={12}
                            sm={4}
                            className="OS---Features-card"
                        >
                            <div>
                                <div className="py-4 mb-3">
                                    <img src={lottery} />
                                </div>
                                <h6>Lottery</h6>
                            </div>
                        </Grid>
                        <Grid
                            xs={12}
                            sm={4}
                            className="OS---Features-card"
                        >
                            <div>
                                <div className="py-4 mb-3">
                                    <img src={governance} />
                                </div>
                                <h6>Governance</h6>
                            </div>
                        </Grid>
                    </Grid>
                </Grid>
            </Container>
        </div>
    )
}

export default Features;